<template>

  <v-app  height="100%" >
<!--    <div style="background-color:  #6bc7fa;  background-image: linear-gradient(to bottom right, #6bc7fa, #bb61e7);"> -->
    <div class="bod" >
<!--
       <div>
                  <span style="color:#f2ea77; font-family: 'Open Sans', sans-serif; font-size: 14px;"> width :: {{width}}  </span>
       </div>
-->
       <div :style="{'padding-bottom':'50px'}">
         <div  v-if="width > 700" style="padding-top:25px; width: 75%; margin-left: auto; margin-right: auto; text-align: center;">
           <v-layout
             justify-space-between
           >
             <div>
                 <v-layout justify-start align-center>
                  <a href="/" ><img src="/img/ccLogo.png"  style="width: 250px"/></a>
                </v-layout>
             </div>
             <div>
                <v-layout justify-space-around align-center style="height:100%">
                   <div><a href="/#goodStuff" ><span class="font-body" :style="{'color': colorOne}">{{ $vuetify.lang.t('$vuetify.theGoodStuff') }} </span></a></div>
                   <div><v-icon :color="colorOne">mdi-slash-forward</v-icon></div>
                   <div><a href="/#behindTheArt" ><span class="font-body" :style="{'color': colorTwo}">{{ $vuetify.lang.t('$vuetify.behindTheArt') }} </span></a></div>
                   <div><v-icon :color="colorTwo">mdi-slash-forward</v-icon></div>
                   <div><a href="/#coreValues" ><span class="font-body" :style="{'color': colorOne}">{{ $vuetify.lang.t('$vuetify.coreValues') }} </span></a></div>
                   <div><v-icon :color="colorOne">mdi-slash-forward</v-icon></div>
                   <div><a href="/#theDreamTeam" ><span class="font-body" :style="{'color': colorTwo}">{{ $vuetify.lang.t('$vuetify.theDreamTeam') }} </span></a></div>
                </v-layout>
             </div>
           </v-layout>
         </div>
         <div v-else style="padding-top:25px; margin-left: auto; margin-right: auto; text-align: center;">
           <!-- <nobr><span class="font-banner-small" :style="{'color': colorOne}">{{ $vuetify.lang.t('$vuetify.cryptoCackles') }} </span></nobr> -->
            <img src="/img/ccLogo.png"  style="width: 250px"/>
         </div>


          <!-- Page Status -->
         <div v-if="width > 1000" style="padding-top:50px">

           <v-layout
              justify-center
            >

              <div >
                <div>
                  <div v-if="isOwner" class="video-outside">
                    <div class="video-inside">
                      <v-btn
                        icon
                        color="white"
                        @click="toggleSoundNFTVideo()"
                      >
                        <v-icon v-if="muteNFT == true"
                         :color="colorSix"
                        >
                          mdi-volume-mute
                        </v-icon>
                        <v-icon v-else
                          :color="colorSix"
                        >
                          mdi-volume-low
                        </v-icon>
                      </v-btn>
                    </div>
                    <video
                       id="NFTVideo"
                       :src="nft[selectedNFT].mp4"
                       autoplay=""
                       loop=""
                       muted="muted"
                       controlsList="nodownload"
                       height="240"
                       :poster="nft[selectedNFT].png"
                       @click="toggleSoundNFTVideo()"
                    >
                    </video>
                  </div>
                </div>

                <div v-if="isOwner">
                  <span class="font-title" :style="{'color': colorOne}"> {{  nft[selectedNFT].name   }}</span>
               </div>
                <div v-if="isOwner">
                  <span class="font-medium-title" :style="{'color': colorOne}"> Member Since:  {{ getDateAndTimeShort( nft[selectedNFT].timestamp )  }}</span>
                </div>
                <div style="padding-top:25px;">
                      <v-btn
                        v-if="nft.length>1"
                        style="text-transform: none;"
                        rounded
                        :color="colorOne"
                        @click="nextNFT()"
                      >
                         Next NFT
                      </v-btn>
                </div>

             </div>
            
             <div  v-if="isOwner" style="padding-top: 15px; width:800px;">
               <div><span class="font-banner-small" :style="{'color': colorOne}"><nobr>{{ $vuetify.lang.t('$vuetify.laughterIsContagious')  }}</nobr></span></div>
               <div  style="padding-top: 8px;"><span class="font-title" :style="{'color': colorOne, 'font-weight': '700'}"><nobr>gm! Welcome to the Laugh Dash!</nobr></span></div>
               <div  style="width:770px; padding-top: 4px;"><span class="font-title" :style="{'color': colorOne}">Here you will find your crypto cackles, including access to each asset you own. From here you can also schedule one-on-one time with Chief Cackles to chat about web3, PR, marketing, ideas through the calendar app as part of your holder utility.</span></div>
             </div>
             <div></div>
          </v-layout>
            
       </div>
       <div v-else style="width: 100%; margin-left: auto; margin-right: auto; text-align: center;">
          <div style="width: 100%;">


            <div v-if="isOwner" class="video-outside">
              <div class="video-inside">
                <v-btn
                  icon
                  color="white"
                  @click="toggleSoundNFTVideo()"
                >
                  <v-icon v-if="muteNFT == true"
                    :color="colorSix"
                  >
                    mdi-volume-mute
                  </v-icon>
                  <v-icon v-else
                    :color="colorSix"
                  >
                     mdi-volume-low
                  </v-icon>
                </v-btn>
              </div>
              <video
                id="NFTVideo"
                :src="nft[selectedNFT].mp4"
                autoplay=""
                loop=""
                muted="muted"
                controlsList="nodownload"
                height="240"
                :poster="nft[selectedNFT].png"
                @click="toggleSoundNFTVideo()"
              >
              </video>
            </div>
            <div v-if="isOwner">
              <span class="font-title" :style="{'color': colorOne}"> {{  nft[selectedNFT].name   }}</span>
            </div>
            <div v-if="isOwner">
               <span class="font-medium-title" :style="{'color': colorOne}"> Member Since:  {{ getDateAndTimeShort( nft[selectedNFT].timestamp )  }}</span>
            </div>
            <div style="padding-top:25px;">
                      <v-btn
                        v-if="nft.length>1"
                        style="text-transform: none;"
                        rounded
                        :color="colorOne"
                        @click="nextNFT()"
                      >
                         Next NFT
                      </v-btn>
             </div>
          </div>

        
          <div style="padding-top:50px;"></div>
            <div  v-if="isOwner"><span class="font-banner-small" :style="{'color': colorOne}">{{ $vuetify.lang.t('$vuetify.laughterIsContagious')  }}</span></div>
            <div  v-if="isOwner" style="padding-top: 8px;"><span class="font-title" :style="{'color': colorOne, 'font-weight': '700'}">gm! Welcome to the Laugh Dash!</span></div>
            <v-layout justify-center><div v-if="isOwner" :style="{'width': width*0.8+'px', 'padding-top': '4px'}"><span class="font-title" :style="{'color': colorOne}">Here you will find your crypto cackles, including access to each asset you own. From here you can also schedule one-on-one time with Chief Cackles to chat about web3, PR, marketing, ideas through the calendar app as part of your holder utility.</span></div></v-layout>
            <div style="padding-top:25px;"></div>

         </div>
      </div>
      <div style="padding-top: 10px"></div>
      <!-- NFT Files -->
      <a id="files"></a>
      <div v-if="calendarLoaded == false" :style="{'padding-top':'50px', 'margin':'auto', 'width': '100%', 'height': height+'px'}">
         <div v-if="w3loaded == false && supportsWallet == true"  style="padding-top:5px; width: 75%; margin-left: auto; margin-right: auto; text-align: center;" >
           <v-layout
               justify-start
            >
             <v-btn
                     style="text-transform: none;"
                     rounded
                     :color="colorOne"
                     @click="loadWeb3()"
                   >
                        Connect Wallet To Access Laugh Dash
             </v-btn>
           </v-layout>
         </div>
         <div v-else-if="supportsWallet == false"  style="padding-top:25px; margin-left: auto; margin-right: auto; text-align: center;" >
            <span class="font-title" :style="{'color': colorOne}">  {{  $vuetify.lang.t('$vuetify.w3Fail')  }} </span>
         </div>
         <div v-else-if="isOwner == false" style="padding-top:25px; margin-left: auto; margin-right: auto; text-align: center;">
            <span class="font-title" :style="{'color': colorOne}">  You must own a Crypto Cackles NFT to access this page </span>
         </div>
      </div>
      <div v-else-if="width>1000"  style="padding-top:50px; margin: auto; width: 100%">
        <v-layout
         justify-center
        >
          <div  :style="{'background-color': colorFour, 'width': '500px', 'padding': '10px' }">
            <div style="width: 100%;  margin: auto; text-align: center; ">
              <span class="font-large-title"  :style="{'color': colorSix }"> Project Stats </span>
            </div>
            <div>
              <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Total NFTS:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.count  }}</span></div>
              </v-layout>
              <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Total Owners:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.num_owners  }}</span></div>
              </v-layout>
              <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Average Price:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.average_price  }}</span></div>
              </v-layout>
               <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Floor Price:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.floor_price  }}</span></div>
              </v-layout>
            </div>
             
          </div>
          <div  :style="{'padding': '10px' }"></div>
          <div  :style="{'background-color': colorFour, 'width': '575px', 'padding': '10px' }" >
            <div style="width: 100%;  margin: auto; text-align: center; ">
              <span class="font-large-title"  :style="{'color': colorSix }"> NFT Files </span>
            </div>
            <div>
              <v-layout justify-space-between align-end >
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Name:</span></div>
                <div style="width: 80%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ nft[selectedNFT].name  }}</span></div>
              </v-layout>
              <v-layout justify-space-between align-end>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Image:</span></div>
                <div style="width: 80%; text-align: left;">
                  <a :href="nft[selectedNFT].png">
                    <span class="font-subtitle" :style="{'color': colorSix, 'text-decoration': 'underline'}">ipfs://{{ nft[selectedNFT].pngIpfs  }}</span>
                  </a>
                </div>
              </v-layout>
              <v-layout justify-space-between align-end>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Animation:</span></div>
                <div style="width: 80%; text-align: left;">
                  <a :href="nft[selectedNFT].mp4">
                    <span class="font-subtitle" :style="{'color': colorSix, 'text-decoration': 'underline'}">ipfs://{{ nft[selectedNFT].mp4Ipfs  }}</span>
                  </a>
                </div>
              </v-layout>
              <v-layout justify-space-between align-start>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Audio Files:</span></div>
                <div style="width: 80%; text-align: left;">
                  <!--  {{ JSON.stringify(nft[selectedNFT]) }}-->
                    <div v-for="audio in nft[selectedNFT].audioFiles"
                      :key="audio.audioFileId"
                    >
                       <div>
                          <a :href="audio.file"><span class="font-subtitle"  :style="{'color': colorSix, 'text-decoration': 'underline'}">ipfs://{{ audio.ipfs }}</span></a>
                       </div>
                       <div> 
                         <audio controls>
                           <source :src="audio.file.replace('aif', 'mp3')" type="audio/mpeg">
                         </audio>
                       </div>
                     </div>
                  </div>
              </v-layout>
              <v-layout justify-space-between align-start>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Traits:</span></div>
                <div style="width: 80%; text-align: left;">
                  <!--  {{ JSON.stringify(nft[selectedNFT]) }}--> 
                  <div v-for="att in nft[selectedNFT].metadataAttribute"
                    :key="att.trait_type"
                  >
                     <span class="font-subtitle" :style="{'color': colorSix}">{{ att.traitType }}: {{ att.value }}</span>
                  </div>
                </div>
              </v-layout>
            </div>
            </div>
         </v-layout>
      </div>


      <!-- Calendar -->
      <a id="calendar"></a>
      <div v-if="calendarLoaded && width>1000" style="padding-top:50px; margin: auto; width: 100%;">
        <v-layout justify-center>
          <div  :style="{'background-color': colorFour, 'width': '500px', 'padding': '10px' }">
            <span class="font-large-title" :style="{'color': colorSix }"> Book Time with Chief Cackles </span>

            <v-stepper v-model="scheduleStep">
              <v-stepper-header>
                <v-stepper-step
                  :complete="scheduleStep > 1"
                  step="1"
                >
                   Select Date
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                   :complete="scheduleStep > 2"
                   step="2"
                >
                   Select Time
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3">
                    Confim
                </v-stepper-step>
             </v-stepper-header>

             <v-stepper-items>
               <v-stepper-content step="1">
                 <v-layout justify-center>
                   <v-date-picker
                     v-model="selectedDate"
                     width="400px"
                     :allowed-dates="allowedDates" 
                     :min="minDate"
                     :max="maxDate"
                     @change="scheduleStepTwo()">
                   </v-date-picker>
                 </v-layout>

             </v-stepper-content>

             <v-stepper-content step="2">
               <div  
                   style ="background-color: #1976D2; border-top-right-radius: 5px; border-top-left-radius: 5px; width: 400px; height: 85px; margin-left:15px"
                   class="mb-2"
               >
                 <div
                   style="padding-top: 10px; padding-left:15px"  
                 ><span class="text-caption" style="color: rgba(255, 255, 255, 0.5)">{{ getYear(selectedDate) }}</span>
                 </div>
                 <div
                   style="padding-left:15px"  
                 ><span class="text-h4" style="color: white">{{ getMonthAndDay(selectedDate) }}</span>
                 </div>
               </div>
               <div
                  v-for="(item, i) in times"
                  :key="'times'+i"
               >
                   <v-layout justify-center>
                     <div 
                       v-if="i%4 == 0"
                       style="width: 400px"
                     >
                       <v-layout justify-start>
                       <div
                          v-for="j in 4"
                          :key="'times'+i+j"
                          style="padding:2px"
                        >
                          <v-btn 
                            v-if="times.length > (j+i-1) && times[j+i-1].open && meetings.length < 3"
                            :color="selectedTimeChosen && selectedTime == i+j-1 ? colorOne : 'rgba(235, 235, 235, 0.5)'"
                            @click="selectedTime = i+j-1; selectedTimeChosen = true; scheduleStep = 3"
                            width="95"
                          >
                            {{ times[j+i-1].text }}
                          </v-btn> 
                          <v-btn
                            v-else-if="times.length > (j+i-1)"
                            color="rgba(235, 235, 235, 0.3)"
                            width="95"
                            disabled
                          >
                            {{ times[j+i-1].text }}
                          </v-btn>
                        </div>
                       </v-layout>   
                     </div>
                   </v-layout>
                </div>
                <div class="mb-12"></div>

                <v-btn text
                  color="primary"
                  @click="scheduleStep = 1"            
                >
                   Back
                </v-btn>
             </v-stepper-content>
             <v-stepper-content step="3">
               <div  
                   style ="background-color: #1976D2; border-top-right-radius: 5px; border-top-left-radius: 5px; width: 400px; height: 85px"
                   class="mb-2"
               >
                 <div
                   style="padding-top: 10px; padding-left:15px"  
                 ><span class="text-caption" style="color: rgba(255, 255, 255, 0.5)">{{ getYear(selectedDate) }}</span>
                 </div>
                 <div
                   style="padding-left:15px"  
                 ><span class="text-h4" style="color: white">{{ getMonthAndDay(selectedDate) }}  {{ times[selectedTime].text }}</span>
                 </div>
               </div>
               <v-text-field
                 v-model="name"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.fullName')"
                 ></v-text-field>
               <v-text-field
                 v-model="mobile"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.mobile')"
                 @input="acceptNumber"
                 ></v-text-field>
               <v-text-field
                 v-model="email"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.emailAddress')"
                 ></v-text-field>
               <v-textarea
                 v-model="description"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.description')"
               ></v-textarea>
               <div style="padding-bottom: 30px; padding-left: 20px">
                 <span class="font-subtitle" style="color: red">  {{ errorMsg  }}  </span>
               </div>
               <v-btn
                  color="primary"
                  @click="scheduleMeeting"
                >
                   Schedule
                </v-btn>

                <v-btn text
                  color="primary"
                  @click="scheduleStep = 2;  errorMsg = ''"            
                >
                   Back
                </v-btn>
             </v-stepper-content>
            </v-stepper-items>
            </v-stepper>
          </div>
          <div  style="padding:10px;"></div>
          <div :style="{'background-color': colorFour, 'width': '575px', 'padding': '10px' }">
            <div  style="text-align: center; margin: auto; width: 100%;">
              <span  class="font-large-title" :style="{'color': colorSix }"> Scheduled Meeting </span>
            </div>
            <div v-if="meetings.length == 0" style="padding-top:20px">
              <span  class="font-big-title" :style="{'color': colorSix }"> No Meeting Scheduled </span>
            </div>
            <div v-else style="padding-top:20px">
              <div v-if="meetings.length > 2" style="padding-bottom:20px">
                 <span  class="font-big-title" :style="{'color': colorSix }"> # Meetings Maximum </span>
              </div>
              <v-list> 
                <template  v-for="(meeting,index) in meetings">
                  <v-list-item
                    :key="meeting.id"
                  >
                  <v-list-item-content>
                    <v-card flat width="100%" @click="">
                      <div>
                         <span class="title font-weight-black">{{ getDateAndTime(meeting.start.dateTime) }}</span> 
                      </div>
                      <div>
                         <span class="subtitle-1">{{ meeting.hangoutLink  }}</span>
                      </div>
                    </v-card>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="cancelMeeting(meeting.id)" >
                      <v-icon color="grey lighten-1" >mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    :key="index"
                    ></v-divider>
                </template> 
              </v-list>
            </div>
            



          </div>
         
        </v-layout>
<!--
        <v-layout justify-center>
           <span class="font-title" :style="{'color': colorOne }"> [ {{ debug  }} ] </span>
        </v-layout>
-->
      <div style="padding-top: 150px"></div>
      </div>
      <div v-else-if="calendarLoaded" >

          <div  :style="{'background-color': colorFour, 'width': '575px', 'margin': 'auto', 'text-align': 'center' }">
            <div style="width: 100%;  margin: auto; text-align: center; ">
              <span class="font-large-title"  :style="{'color': colorSix }"> Project Stats </span>
            </div>
            <div>
              <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Total NFTS:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.count  }}</span></div>
              </v-layout>
              <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Total Owners:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.num_owners  }}</span></div>
              </v-layout>
              <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Average Price:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.average_price  }}</span></div>
              </v-layout>
               <v-layout justify-space-between align-end >
                <div style="width: 40%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Floor Price:</span></div>
                <div style="width: 60%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ stats.floor_price  }}</span></div>
              </v-layout>
            </div>
             
          </div>
          <div  :style="{'padding-top': '10px' }"></div>
          <div  :style="{'background-color': colorFour, 'width': '575px', 'margin': 'auto', 'text-align': 'center' }" >
            <div style="width: 100%;  margin: auto; text-align: center; ">
              <span class="font-large-title"  :style="{'color': colorSix }"> NFT Files </span>
            </div>
            <div>
              <v-layout justify-space-between align-end >
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Name:</span></div>
                <div style="width: 80%; text-align: left;"><span class="font-subtitle" :style="{'color': colorSix}">{{ nft[selectedNFT].name  }}</span></div>
              </v-layout>
              <v-layout justify-space-between align-end>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Image:</span></div>
                <div style="width: 80%; text-align: left;">
                  <a :href="nft[selectedNFT].png">
                    <span class="font-subtitle" :style="{'color': colorSix, 'text-decoration': 'underline'}">ipfs://{{ nft[selectedNFT].pngIpfs  }}</span>
                  </a>
                </div>
              </v-layout>
              <v-layout justify-space-between align-end>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Animation:</span></div>
                <div style="width: 80%; text-align: left;">
                  <a :href="nft[selectedNFT].mp4">
                    <span class="font-subtitle" :style="{'color': colorSix, 'text-decoration': 'underline'}">ipfs://{{ nft[selectedNFT].mp4Ipfs  }}</span>
                  </a>
                </div>
              </v-layout>
              <v-layout justify-space-between align-start>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Audio Files:</span></div>
                <div style="width: 80%; text-align: left;">
                  <!--  {{ JSON.stringify(nft[selectedNFT]) }}-->
                    <div v-for="audio in nft[selectedNFT].audioFiles"
                      :key="audio.audioFileId"
                    >
                       <div>
                          <a :href="audio.file"><span class="font-subtitle"  :style="{'color': colorSix, 'text-decoration': 'underline'}">ipfs://{{ audio.ipfs }}</span></a>
                       </div>
                       <div> 
                         <audio controls>
                           <source :src="audio.file.replace('aif', 'mp3')" type="audio/mpeg">
                         </audio>
                       </div>
                     </div>
                  </div>
              </v-layout>
              <v-layout justify-space-between align-start>
                <div style="width: 20%; text-align: left;"><span class="font-medium-title" :style="{'color': colorSix}">Traits:</span></div>
                <div style="width: 80%; text-align: left;">
                  <!--  {{ JSON.stringify(nft[selectedNFT]) }}--> 
                  <div v-for="att in nft[selectedNFT].metadataAttribute"
                    :key="att.trait_type"
                  >
                     <span class="font-subtitle" :style="{'color': colorSix}">{{ att.traitType }}: {{ att.value }}</span>
                  </div>
                </div>
              </v-layout>
            </div>
            </div>



          <div  style="padding-top:10px;"></div>
          <div  :style="{'background-color': colorFour, 'width': '575px', 'margin': 'auto', 'text-align': 'center' }">
            <span class="font-large-title" :style="{'color': colorSix }"> Book Time with Chief Cackles </span>

            <div style="width:500px; margin: auto; text-align: center">
            <v-stepper v-model="scheduleStep">
              <v-stepper-header>
                <v-stepper-step
                  :complete="scheduleStep > 1"
                  step="1"
                >
                   Select Date
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                   :complete="scheduleStep > 2"
                   step="2"
                >
                   Select Time
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3">
                    Confim
                </v-stepper-step>
             </v-stepper-header>

             <v-stepper-items>
               <v-stepper-content step="1">
                 <v-layout justify-center>
                   <v-date-picker
                     v-model="selectedDate"
                     width="400px"
                     :allowed-dates="allowedDates" 
                     :min="minDate"
                     :max="maxDate"
                     @change="scheduleStepTwo()">
                   </v-date-picker>
                 </v-layout>

             </v-stepper-content>

             <v-stepper-content step="2">
               <div  
                   style ="background-color: #1976D2; border-top-right-radius: 5px; border-top-left-radius: 5px; width: 400px; height: 85px; margin-left:15px"
                   class="mb-2"
               >
                 <div
                   style="padding-top: 10px; padding-left:15px"  
                 ><span class="text-caption" style="color: rgba(255, 255, 255, 0.5)">{{ getYear(selectedDate) }}</span>
                 </div>
                 <div
                   style="padding-left:15px"  
                 ><span class="text-h4" style="color: white">{{ getMonthAndDay(selectedDate) }}</span>
                 </div>
               </div>
               <div
                  v-for="(item, i) in times"
                  :key="'times'+i"
               >
                   <v-layout justify-center>
                     <div 
                       v-if="i%4 == 0"
                       style="width: 400px"
                     >
                       <v-layout justify-start>
                       <div
                          v-for="j in 4"
                          :key="'times'+i+j"
                          style="padding:2px"
                        >
                          <v-btn 
                            v-if="times.length > (j+i-1) && times[j+i-1].open && meetings.length < 3"
                            :color="selectedTimeChosen && selectedTime == i+j-1 ? colorOne : 'rgba(235, 235, 235, 0.5)'"
                            @click="selectedTime = i+j-1; selectedTimeChosen = true; scheduleStep = 3"
                            width="95"
                          >
                            {{ times[j+i-1].text }}
                          </v-btn> 
                          <v-btn
                            v-else-if="times.length > (j+i-1)"
                            color="rgba(235, 235, 235, 0.3)"
                            width="95"
                            disabled
                          >
                            {{ times[j+i-1].text }}
                          </v-btn>
                        </div>
                       </v-layout>   
                     </div>
                   </v-layout>
                </div>
                <div class="mb-12"></div>

                <v-btn text
                  color="primary"
                  @click="scheduleStep = 1"            
                >
                   Back
                </v-btn>
             </v-stepper-content>
             <v-stepper-content step="3">
               <div  
                   style ="background-color: #1976D2; border-top-right-radius: 5px; border-top-left-radius: 5px; width: 400px; height: 85px"
                   class="mb-2"
               >
                 <div
                   style="padding-top: 10px; padding-left:15px"  
                 ><span class="text-caption" style="color: rgba(255, 255, 255, 0.5)">{{ getYear(selectedDate) }}</span>
                 </div>
                 <div
                   style="padding-left:15px"  
                 ><span class="text-h4" style="color: white">{{ getMonthAndDay(selectedDate) }}  {{ times[selectedTime].text }}</span>
                 </div>
               </div>
               <v-text-field
                 v-model="name"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.fullName')"
                 ></v-text-field>
               <v-text-field
                 v-model="mobile"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.mobile')"
                 @input="acceptNumber"
                 ></v-text-field>
               <v-text-field
                 v-model="email"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.emailAddress')"
                 ></v-text-field>
               <v-textarea
                 v-model="description"
                 background-color="rgba(255, 255, 255, 0.7)"
                 color="black"
                 solo
                 outlined
                 hide-details
                 :label="$vuetify.lang.t('$vuetify.description')"
               ></v-textarea>
               <div style="padding-bottom: 30px; padding-left: 20px">
                 <span class="font-subtitle" style="color: red">  {{ errorMsg  }}  </span>
               </div>
               <v-btn
                  color="primary"
                  @click="scheduleMeeting"
                >
                   Schedule
                </v-btn>

                <v-btn text
                  color="primary"
                  @click="scheduleStep = 2;  errorMsg = ''"            
                >
                   Back
                </v-btn>
             </v-stepper-content>
            </v-stepper-items>
            </v-stepper>
            </div>
          </div>
          <div  style="padding-top:10px;"></div>
          <div :style="{'background-color': colorFour, 'width': '575px', 'margin': 'auto', 'text-align': 'center' }">
            <div  style="text-align: center; margin: auto; width: 100%;">
              <span  class="font-large-title" :style="{'color': colorSix }"> Scheduled Meeting </span>
            </div>
            <div v-if="meetings.length == 0" style="padding-top:20px">
              <span  class="font-big-title" :style="{'color': colorSix }"> No Meeting Scheduled </span>
            </div>
            <div v-else style="padding-top:20px">
              <div v-if="meetings.length > 2" style="padding-bottom:20px">
                 <span  class="font-big-title" :style="{'color': colorSix }"> # Meetings Maximum </span>
              </div>
              <v-list> 
                <template  v-for="(meeting,index) in meetings">
                  <v-list-item
                    :key="meeting.id"
                  >
                  <v-list-item-content>
                    <v-card flat width="100%" @click="">
                      <div>
                         <span class="title font-weight-black">{{ getDateAndTime(meeting.start.dateTime) }}</span> 
                      </div>
                      <div>
                         <span class="subtitle-1">{{ meeting.hangoutLink  }}</span>
                      </div>
                    </v-card>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="cancelMeeting(meeting.id)" >
                      <v-icon color="grey lighten-1" >mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    :key="index"
                    ></v-divider>
                </template> 
              </v-list>
            </div>
            <div  style="padding-top:10px;"></div>



          </div>
          <div  style="padding-top:18px;"></div>

      </div>
     </div>
  </v-app>
</template>
<script>
import Web3 from 'web3'
import Cackles from './artifacts/contracts/Cackles.json'
import ENV from './env-config.json'

export default {
  name: 'Site',
  data: function() {
    return {
      isOwner: false,
      supportsWallet: false,
      w3loaded: false,
      walletId: '',
      nft: [],
      nftPurchaseDate: [],
      selectedNFT: 0,
      meetings: [],
      muteNFT: true,
      errorMsg: '',
      nfts: [],
      w3: {},
      height: 900,
      width: 900,
      colorOne: '#f2ea77',
      colorTwo: '#acfce8',
      colorThree: '#7eebe0',
      colorFour: '#68d492',
      colorFive:  '#91f57f',
      colorSix:  '#f2f2f2',
      calItems: [],
      calSaved: [],
      calendarLoaded: false,
      selectedTimeChosen: false,
      selectedDate: '2022-02-01',
      selectedTime: 0,
      name: '',
      mobile: '',
      email: '',
      description: '',
      scheduleStep: 1,
      minDate: '2022-02-01',
      maxDate: '2050-02-01',
      times: [
        { text: '9:00am', start: '09:00', end: '09:30', h: 9, sm: 0, em: 29, open: true },
        { text: '9:30am', start: '09:30', end: '10:00', h: 9, sm: 30, em: 59, open: true },
        { text: '10:00am', start: '10:00', end: '10:30', h: 10, sm: 0, em: 29,open: true },
        { text: '10:30am', start: '10:30', end: '11:00' ,h: 10, sm: 30, em: 59, open: true },
        { text: '11:00am', start: '11:00', end: '11:30', h: 11, sm: 0, em: 29, open: true },
        { text: '11:30am', start: '11:30', end: '12:00', h: 11, sm: 30, em: 59, open: true },
        { text: '12:00pm', start: '12:00', end: '12:30', h: 12, sm: 0, em: 29, open: true },
        { text: '12:30pm', start: '12:30', end: '13:00', h: 12, sm: 30, em: 59, open: true },
        { text: '1:00pm', start: '13:00', end: '13:30', h: 13, sm: 0, em: 29, open: true },
        { text: '1:30pm', start: '13:30', end: '14:00', h: 13, sm: 30, em: 59, open: true },
        { text: '2:00pm', start: '14:00', end: '14:30', h: 14, sm: 0, em: 29, open: true },
        { text: '2:30pm', start: '14:30', end: '15:00', h: 14, sm: 30, em: 59, open: true },
        { text: '3:00pm', start: '15:00', end: '15:30', h: 15, sm: 0,  em: 29, open: true },
        { text: '3:30pm', start: '15:30', end: '16:00', h: 15, sm: 30, em: 59, open: true },
        { text: '4:00pm', start: '16:00', end: '16:30', h: 16, sm: 0, em: 29, open: true },
        { text: '4:30pm', start: '16:30', end: '17:00', h: 16, sm: 30, em: 59, open: true },
      ],
      stats: {
         one_day_volume: 0,
         one_day_change: 0,
         one_day_sales: 0,
         one_day_average_price: 0,
         seven_day_volume: 0,
         seven_day_change: 0,
         seven_day_sales: 0,
         seven_day_average_price: 0,
         thirty_day_volume: 0,
         thirty_day_change: 0,
         thirty_day_sales: 0,
         thirty_day_average_price: 0,
         total_volume: 0,
         total_sales: 0,
         total_supply: 0,
         count: 0,
         num_owners: 0,
         average_price: 0,
         num_reports: 0,
         market_cap: 0,
         floor_price: null
      },
      disabled: false,
      debug: ''
    
    }
  },
  mounted() {
    this.$nextTick(function() {
       window.addEventListener('resize', this.setHeightWidth);
      //Init
       this.setHeightWidth();
          
      });
    this.checkWallet(); 
    this.projectStats();
    //this.loadCalendar();
  },
  methods: {
    setHeightWidth(event) {
      this.removeWarning = event;
      this.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.height =  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    },
    async loadWeb32() {
      var self = this;
      if (window.ethereum) {
        web3 = new Web3(window.ethereum);
        //web3.eth.getAccounts(function(err, accounts){
        //  if (err != null) alert("An error occurred: "+err);
        //  else if (accounts.length == 0) alert("User is not logged in to MetaMask");
        //  else alert("User is logged in to MetaMask");
        //});
        alert("mm:"+window.ethereum.isMetaMask);
        //alert(window.ethereum.isToshi);

        await window.ethereum.request({ method: 'eth_requestAccounts' });
        //await window.ethereum.send('eth_requestAccounts');
        this.w3 = new Web3(window.ethereum);
        //this.debug = JSON.stringify(this.w3.eth.currentProvider.constructor);
        //alert( JSON.stringify(this.w3.currentProvider.isMetaMask));
        //this.checkOwners('0xe70EC74d426EeCE82dAF44bB7999E0760b2B5b4e');
        this.w3.eth.getAccounts().then(function(response) { self.checkOwners(response[0]);  });
        this.w3loaded = true;
      } else if (window.web3) {
        this.w3 = new Web3(window.web3.currentProvider);
        this.w3.eth.getAccounts().then(function(response) { self.checkOwners(response[0]) });
        this.w3loaded = true;
      } 
    },
    async checkWallet() {
      var self = this;
      if (window.ethereum || window.web3) {
        this.supportsWallet = true;
        web3 = new Web3(window.ethereum);
        //this.walletNetworkId = await web3.eth.net.getId();
        web3.eth.getAccounts(function(err, accounts){
          if (err != null) {
            alert("An error occurred: "+err);
          } else if (accounts.length == 0) {
            // "User is not logged in to a wallet
          } else {
            // User is logged in to MetaMask
            self.loadWeb3();
          }
        });
      } else if (window.web3) {
        this.supportsWallet = true;
        web3 = new Web3(window.web3.currentProvider);
        this.walletNetworkId = await web3.eth.net.getId();
        web3.eth.getAccounts(function(err, accounts){
          if (err != null) {
            alert("An error occurred: "+err);
          } else if (accounts.length == 0) {
            // "User is not logged in to a wallet
          } else {
            // User is logged in to MetaMask
            self.loadWeb3();
          }
        });
      }
    },
    async loadWeb3() {
      var self = this;
      if (window.ethereum) {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        //await window.ethereum.send('eth_requestAccounts');
        this.w3 = new Web3(window.ethereum);
        this.w3.eth.getAccounts().then(function(response) { self.checkOwners(response[0]);  });
        this.w3loaded = true;
      } else if (window.web3) {
        this.w3 = new Web3(window.web3.currentProvider);
        this.w3.eth.getAccounts().then(function(response) { self.checkOwners(response[0]) });
        this.w3loaded = true;
      } 
    },
    async checkOwners(id) {
      this.walletId = id;
      var self = this;
       const abi = Cackles.abi;
      try {
           let contract = new this.w3.eth.Contract(abi, ENV.contract_address);
           var obj = { fromBlock: 9499430, toBlock: "latest", filter: {to: id} };
            obj = { fromBlock: 9, toBlock: "latest", filter: {to: id} };
           //let events = await contract.getPastEvents("Transfer");
           // let events = await contract.events.allEvents();
           contract.getPastEvents("Transfer",obj,
              (err, events) => {
                if (!err) {
                      //self.dump = self.dump+"[L]:"+events.length;
                      self.parseEvent(contract, events, id);
                } else {
                  alert(err);
                }
              });

       } catch (err) {
           alert("Unable to connect to NFT Contract\nError:"+err);
       }
    },
    async parseEvent(contract, events, id) {
      let foundNFT = false;
      let index = 0;
       for (let i =0; i < events.length; i++) {
          let own = await contract.methods.ownerOf(events[i].returnValues.tokenId).call();
          if (own == id) {
            let blockData = await this.w3.eth.getBlock(events[i].blockNumber);
            this.nftPurchaseDate.push({ 'timestamp': blockData.timestamp });
            let self = this;
            let obj = { tokenId: events[i].returnValues.tokenId, pd: blockData.timestamp }
            fetch("/cc/metadata", {
              method: 'POST',
              headers: {
              Accept: 'application/json',
               'Content-Type': 'application/json'
              },
              body: JSON.stringify(obj)
              }).then(function(response) {

              return response.json()
              }).then(function(resp) {
                 let md = resp.metadata;
                 md.timestamp = resp.pd;
                 self.nft.push(md);                 
                 self.isOwner = true;
                 foundNFT = true;
                 index++;
                 return;
              })
                .catch(function(error) {
                  self.dummy = error;
                  alert(error);
              })



/*
            let tokenURI = await contract.methods.tokenURI(events[i].returnValues.tokenId).call();
            var self = this;
            fetch(tokenURI, {
              method: 'GET',
              headers: {
                Accept: 'application/json',
              },
              }).then(function(response) {
               return response.json()
              }).then(function(resp) {
                resp.tokenId = events[i].returnValues.tokenId;
                self.nft.push(resp);
                self.isOwner = true;
                //if (flag) {
                  foundNFT = true;
                //  self.loadCalendar();
                //}
                index++;
                return;
              })
             .catch(function(error) {
                alert(error);
             });
*/

          } else {
             index++;
          }
       }
       while(index < events.length) {
          await this.sleep(100);
       }
       if (foundNFT) {
         this.loadCalendar();
       }
    },
    sleep(ms) {
       return new Promise(resolve => setTimeout(resolve, ms));
    },
    async loadCalendar() {
      let d = new Date();
      let startTimeStamp = 0;
      for (let i=0; i < this.nftPurchaseDate.length; i++) {
        if (startTimeStamp == 0 || startTimeStamp > this.nftPurchaseDate[i].timestamp) {
           startTimeStamp = this.nftPurchaseDate[i].timestamp;
        }
      }
      let startDate = new Date(d.getFullYear(), d.getMonth(), d.getDate()+7);
      let endDate = new Date(d.getFullYear(), d.getMonth()+6, d.getDate());
      this.minDate = startDate.toISOString().slice(0,10);
      this.maxDate = endDate.toISOString().slice(0,10);
      this.selectedDate = this.minDate;
      this.calendarLoaded=  true;
      var self = this;
      this.disabled = true;
      var obj = { action: 'fetch', startDate: startTimeStamp }
       fetch("/cc/calendar", {
         method: 'POST',
         headers: {
           Accept: 'application/json',
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(obj)
        }).then(function(response) {
          
          return response.json()
        }).then(function(resp) {
          if (!resp.success) {
            alert("error reading calendar");
            return;
          }
          let events = resp.primary;
          self.calItems = [];
          self.calSaved = [];
          for (let i = 0; i < events.length; i++) {
            if (events[i].start.dateTime) {
              let start = events[i].start.dateTime.split("T",2);
              if (!self.calItems[start[0]]) {
                self.calItems[start[0]] = [];
              }
              self.calItems[start[0]].push({ start: start[1].substring(0,5), end: events[i].end.dateTime.substring(11,16) });
            } else if (events[i].start.date) {
              if (!self.calItems[events[i].start.date]) {
                self.calItems[events[i].start.date] = [];
              }
              self.calItems[events[i].start.date].push({ start: '00:00', end: '23:50' });
            }
          }
          events = resp.saved;
          for (let i = 0; i < events.length; i++) {
            if (events[i].start.dateTime) {
              let start = events[i].start.dateTime.split("T",2);
              if (!self.calItems[start[0]]) {
                self.calItems[start[0]] = [];
              }
              self.calItems[start[0]].push({ start: start[1].substring(0,5), end: events[i].end.dateTime.substring(11,16) });
            } else if (events[i].start.date) {
              if (!self.calItems[events[i].start.date]) {
                self.calItems[events[i].start.date] = [];
              }
              self.calItems[events[i].start.date].push({ start: '00:00', end: '23:50' });
            }
            self.calSaved.push(events[i]);
            if (self.nft.length > 0) {
              let check = self.walletId.toLowerCase().substring(2)+self.nft[0].tokenId+"t";
              if (events[i].id.startsWith(check)) {
                self.meetings.push(events[i]);
              }


            }
          }
          events = resp.blocked;
          for (let i = 0; i < events.length; i++) {            
            if (events[i].start.dateTime) {
              let start = events[i].start.dateTime.split("T",2);
              if (!self.calItems[start[0]]) {
                self.calItems[start[0]] = [];
              }            
              self.calItems[start[0]].push({ start: start[1].substring(0,5), end: events[i].end.dateTime.substring(11,16) });
            } else if (events[i].start.date) {
              if (!self.calItems[events[i].start.date]) {
                self.calItems[events[i].start.date] = [];
              }
              self.calItems[events[i].start.date].push({ start: '00:00', end: '23:50' });
            }
          }
          
          return;
        })
        .catch(function(error) {
          self.disabled = false;
          self.debug = error;
        })
    },
    scheduleStepTwo() {
      for (let h=0; h < this.times.length; h++) {
        this.times[h].open = true;
      }
      if (this.calItems[this.selectedDate]) {
        for (let i=0; i < this.calItems[this.selectedDate].length; i++) {
          let startTime =  this.calItems[this.selectedDate][i].start.split(":",2);
          let endTime = this.calItems[this.selectedDate][i].end.split(":",2);
          let flag = false;
          let d = new Date();
          let startDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(),  startTime[0], startTime[1]);
          let endDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(),  endTime[0], endTime[1]);
          for (let j=0; j < this.times.length; j++) {
            let checkStartDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), this.times[j].h, this.times[j].sm);
            let checkEndDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(),  this.times[j].h, this.times[j].em);
            let check1 = checkStartDate >= startDate && checkStartDate < endDate;
            let check2 = checkEndDate >= startDate && checkEndDate < endDate;
            if (check1 || check2) {
              this.times[j].open = false;
            }
          }
        }
      }
      this.selectedTimeChosen = false;
      this.scheduleStep = 2;
    },
    acceptNumber() {
      let x = this.mobile.replace(/[^\d]/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.mobile = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    scheduleMeeting() {
      this.acceptNumber();
      let ok = true;
      if (this.mobile.length != 14) {
        this.errorMsg = this.$vuetify.lang.t('$vuetify.errorPhone');
        ok = false;
      }
      let emailValid = RegExp("^[a-zA-Z0-9.-_+]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]+").test(this.email);
      if (!emailValid) {
        this.errorMsg =  this.$vuetify.lang.t('$vuetify.errorEmailAddress');
        ok = false;
      }
      if (ok) {
        var self = this;
        this.disabled = true;
        var obj = { 
          action: 'insert', 
          walletId: this.walletId, 
          date: this.selectedDate,
          startTime: this.times[this.selectedTime].start,
          endTime: this.times[this.selectedTime].end,
          description: this.description,
          name: this.name,
          email: this.email,
          mobile: this.mobile,
          summary: this.nft[this.selectedNFT].name,
          tokenId:  this.nft[this.selectedNFT].tokenId
        }
         fetch("/cc/calendar", {
           method: 'POST',
           headers: {
             Accept: 'application/json',
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(obj)
          }).then(function(response) {

            return response.json()
          }).then(function(resp) {
            if (resp.success) {
              self.meetings.push(resp.saved);
              self.calSaved.push(resp.saved);
              self.scheduleStep = 1;
            } else {
              alert("Error: Unable to create meeting");
            }
            return;
          })
          .catch(function(error) {
            self.disabled = false;
            self.debug = error;
          });
      }

    },
    cancelMeeting(id) {
       var self = this;
       this.disabled = true;
       var obj = {
          action: 'cancel',
          id: id,
       }
        fetch("/cc/calendar", {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(obj)
         }).then(function(response) {

           return response.json()
         }).then(function(resp) {
           if (resp.success) {
             for (let i =0; i < self.meetings.length; i++) {
                if (self.meetings[i].id == id) {
                 self.meetings.splice(i, 1);  
                }
             }
             for (let i =0; i < self.calSaved.length; i++) {
                if (self.calSaved[i].id == id) {
                  self.calSaved.splice(i, 1);
                }
             }
           } else {
              alert("Error: Unable to cancel meeting");
           }
           return;
         })
         .catch(function(error) {
           self.disabled = false;
           self.debug = error;
         });

    },
    projectStats() {
            
            var self = this;
            fetch('https://api.opensea.io/api/v1/collection/crypto-cackles/stats', {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'X-API-KEY': '71e4bcfba687476daf0be3dcdb4368e4'
              },
              }).then(function(response) {
               return response.json()
              }).then(function(resp) {
                self.stats = resp.stats;
                return;
              })
             .catch(function(error) {
                alert(error);
             });
  
      //curl --request GET \
    // --url https://api.opensea.io/api/v1/collection/crypto-cackles/stats \
    // --header 'Accept: application/json' \
    // --header 'X-API-KEY: 71e4bcfba687476daf0be3dcdb4368e4'
    /*

{
  "stats": {
    "one_day_volume": 0,
    "one_day_change": 0,
    "one_day_sales": 0,
    "one_day_average_price": 0,
    "seven_day_volume": 0,
    "seven_day_change": 0,
    "seven_day_sales": 0,
    "seven_day_average_price": 0,
    "thirty_day_volume": 0,
    "thirty_day_change": 0,
    "thirty_day_sales": 0,
    "thirty_day_average_price": 0,
    "total_volume": 0,
    "total_sales": 0,
    "total_supply": 20,
    "count": 20,
    "num_owners": 20,
    "average_price": 0,
    "num_reports": 0,
    "market_cap": 0,
    "floor_price": null
  }
}


    */

    
    
    },
    toggleSoundNFTVideo() {
      let video = document.getElementById("NFTVideo");
      video.muted = !video.muted;
      this.muteNFT = video.muted;
    },
    nextNFT() {
      if (this.selectedNFT == this.nft.length -1) {
         this.selectedNFT = 0;
      } else {
         this.selectedNFT++;
      }
      this.meetings = [];
      let check = this.walletId.toLowerCase().substring(2)+this.nft[this.selectedNFT].tokenId+"t";
      for (let i=0; i < this.calSaved.length; i++) {
        if ( this.calSaved[i].id.startsWith(check)) {
          this.meetings.push( this.calSaved[i]);
        }
      }
    },
    prevMonth(cal) {
      cal.prev();
    },
    nextMonth(cal) {
      cal.next();
      this.calendarTitle = this.getMonthYear(this.today);
    },
    showDate (e) {
      alert(JSON.stringify(e));
    },
    allowedDates(val) { 
      let valDate = new Date(val);
      let d = valDate.getDay();
      if (d ==1 || d==2 || d==3 || d==4 || d==0) {
        return true;
      } else {
        return false;
      }
      
    },
    getNFTs() {
       this.nfts = [];
       let isAddress  = RegExp("^0x[a-zA-Z0-9]+$").test(this.walletId);
       if (isAddress) {
         //this.walletId =  "0x511ce1412b01c3af876120b0cff8c19873c55d49"
         var self = this;
         this.disabled = true;
         fetch("https://eth-mainnet.g.alchemy.com/F2rLM38INAc1NzEd-6tpIXDn6RgUaOlT/v1/getNFTs/?owner="+this.walletId, {
           method: 'GET',
           headers: {
             Accept: 'application/json',
             'Content-Type': 'application/json'
           },
          }).then(function(response) {
            return response.json()
          }).then(function(resp) {
            self.addNFTS(resp);
/*
            for (let i=0; i < resp.ownedNfts.length; i++) {
                if (resp.ownedNfts[i].contract.address == '0xba30e5f9bb24caa003e9f2f0497ad287fdf95623') {
                   self.addNFT(resp.ownedNfts[i].contract.address, parseInt(resp.ownedNfts[i].id.tokenId,16));
                }
            } 
*/
            return;
          })
          .catch(function(error) {
            self.disabled = false;
            self.dummy = error;
            self.errorMsg =  error;
          })
       } else {
         this.errorMsg =  this.isHex(this.walletId);
       }
    },
    async addNFTS(nfts) {
      for (let i=0; i < nfts.ownedNfts.length; i++) {
    //    if (nfts.ownedNfts[i].contract.address == '0xba30e5f9bb24caa003e9f2f0497ad287fdf95623') {
             this.addNFT(nfts.ownedNfts[i].contract.address, parseInt(nfts.ownedNfts[i].id.tokenId,16), nfts.ownedNfts.length);
      //  }
      }
    },
    async addNFT(contractAddress, id, len) {
       var self = this;
       fetch("https://eth-mainnet.g.alchemy.com/F2rLM38INAc1NzEd-6tpIXDn6RgUaOlT/v1/getNFTMetadata?tokenId="+id+'&contractAddress='+contractAddress+"&tokenType:erc722", {
           method: 'GET',
           headers: {
             Accept: 'application/json',
             'Content-Type': 'application/json'
           },
          }).then(function(response) {
            return response.json()
          }).then(function(resp) {
            self.nfts.push(resp);
            if (self.nfts.length == len) {
               this.disabled = false;
            }
            return;
          })
          .catch(function(error) {
            self.dummy = error;
            self.errorMsg =  "["+id+"]:"+error;
          })
    },
    getDateAndTime(date1) {
       var d = new Date(date1);
       let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute:'numeric', timeZone: 'America/New_York' };
       return d.toLocaleDateString('en', options);
    },
    getDateAndTimeShort(date1) {
       var d = new Date(date1*1000);
       let options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };
       return d.toLocaleDateString('en', options);
    },
    getMonthYear(date1) {
       var d = new Date(date1);
       let options = { year: 'numeric', month: 'long', timeZone: 'UTC' };
       return d.toLocaleDateString('en', options);
    },
    getMonthAndDay(date1) {
       var d = new Date(date1);
       let options = { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' };
       return d.toLocaleDateString('en', options);
    },
    getYear(date1) {
       var d = new Date(date1);
       return d.getFullYear();
    },
    getMobileOperatingSystem() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
          return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      return "notMobile";
    },
    arrayVal(a,b) {
      if (a ==1) {
         return 0;
      } else if (a==2) {
         return b;
      } else {
         return b+2;
      }
    },

   },
   beforeDestroy() {
       window.removeEventListener('resize', this.getWindowHeight);
       window.removeEventListener('message', this.getCalendar);
       clearInterval(this.intervalid);
   }
}
</script>
